import { useState, useEffect } from 'react';
import { api } from '../api/client';
import ResourceManager from './ResourceManager';

const FIELDS = [
  { key: 'sponsorship.section_title', label: 'Titre de section', type: 'text' },
  { key: 'sponsorship.section_subtitle', label: 'Sous-titre', type: 'text' },
  { key: 'sponsorship.plan_name', label: 'Nom du plan', type: 'text' },
  { key: 'sponsorship.plan_price_amount', label: 'Montant', type: 'text' },
  { key: 'sponsorship.plan_price_currency', label: 'Devise', type: 'text' },
  { key: 'sponsorship.cta_title', label: 'Titre bloc entreprise', type: 'text' },
  { key: 'sponsorship.cta_text', label: 'Texte bloc entreprise', type: 'textarea' },
  { key: 'sponsorship.cta_email', label: 'Email de contact entreprise', type: 'text' }
];

function SponsorshipSettingsForm() {
  const [settings, setSettings] = useState({});
  const [planFeaturesText, setPlanFeaturesText] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    api.getSettings().then((data) => {
      setSettings(data);
      try {
        const parsed = JSON.parse(data['sponsorship.plan_features'] || '[]');
        setPlanFeaturesText(parsed.join('\n'));
      } catch {
        setPlanFeaturesText('');
      }
    }).catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    setSuccess('');
    setError('');
    try {
      const payload = { ...settings };
      FIELDS.forEach((f) => { payload[f.key] = settings[f.key] || ''; });
      payload['sponsorship.plan_features'] = JSON.stringify(
        planFeaturesText.split('\n').map((s) => s.trim()).filter(Boolean)
      );
      await api.updateSettings(payload);
      setSuccess('Modifications enregistrées.');
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="admin-panel"><p>Chargement…</p></div>;

  return (
    <div className="admin-panel">
      <div className="admin-panel-header">
        <h2>Parrainage — plan et textes</h2>
      </div>
      {error && <div className="admin-error">{error}</div>}
      {success && <div className="admin-success">{success}</div>}

      <div className="admin-form">
        {FIELDS.map((f) => (
          <div className="admin-form-row" key={f.key}>
            <label>{f.label}</label>
            {f.type === 'textarea' ? (
              <textarea
                rows={3}
                value={settings[f.key] || ''}
                onChange={(e) => setSettings((prev) => ({ ...prev, [f.key]: e.target.value }))}
              />
            ) : (
              <input
                type="text"
                value={settings[f.key] || ''}
                onChange={(e) => setSettings((prev) => ({ ...prev, [f.key]: e.target.value }))}
              />
            )}
          </div>
        ))}
      </div>

      <div className="admin-settings-group">
        <h3>Avantages inclus dans le plan (liste affichée dans la carte)</h3>
        <p className="admin-hint">Un avantage par ligne.</p>
        <textarea
          rows={5}
          value={planFeaturesText}
          onChange={(e) => setPlanFeaturesText(e.target.value)}
        />
      </div>

      <div className="admin-form-actions">
        <button className="admin-btn admin-btn-primary" onClick={save} disabled={saving}>
          {saving ? 'Enregistrement…' : 'Enregistrer'}
        </button>
      </div>
    </div>
  );
}

function SponsorshipManager() {
  return (
    <>
      <SponsorshipSettingsForm />
      <div style={{ height: 24 }} />
      <ResourceManager
        resource="sponsorship-benefits"
        title="Avantages du parrainage (cartes)"
        fields={[
          { key: 'icon', label: 'Icône (emoji)', type: 'text' },
          { key: 'title', label: 'Titre', type: 'text' },
          { key: 'description', label: 'Description', type: 'textarea' }
        ]}
      />
    </>
  );
}

export default SponsorshipManager;
